// Канонический вид пути страницы витрины: строчные буквы и слеш на конце.
// Используется серверным редиректом (server-middleware/seo-redirects.js)
// и клиентской навигацией (plugins/trailing-slash.client.ts).

// Пути, которые обслуживает не витрина, а Битрикс или сборка Nuxt
const SKIP_PREFIXES = [
  '/api/',
  '/_nuxt/',
  '/assets/',
  '/bitrix/',
  '/upload/',
  '/cron/',
  '/local/',
  '/static/',
  '/__webpack_hmr',
  '/_loading/',
]

// Точка в последней части адреса — это файл (robots.txt, site.webmanifest)
const FILE_EXTENSION = /\.[^/]*$/

export function isSitePagePath(path) {
  if (!path || path[0] !== '/' || path.includes('//')) {
    return false
  }
  if (SKIP_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return false
  }
  return !FILE_EXTENSION.test(path)
}

// Коды вида %D0%9A не трогаем: кириллица в пути приходит именно так
export function normalizeSitePath(path) {
  if (!isSitePagePath(path)) {
    return path
  }
  const lower = path.replace(/%[0-9a-f]{2}|[^%]+/gi, (part) =>
    part[0] === '%' ? part : part.toLowerCase()
  )
  return lower.endsWith('/') ? lower : lower + '/'
}
